import type { IGenericFeature, IGenericFeatureDto } from "./IGenericFeature";

export class GenericFeature implements IGenericFeature
{

    isEnabledInAppSettings: boolean;
    title: string;

    constructor( model: IGenericFeatureDto )
    {
        this.title = model.title;
        this.isEnabledInAppSettings = model.isEnabledInAppSettings;
    }

    /**
     * True if the feature is enabled
     */
    get isEnabled()
    {
        return this.isEnabledInAppSettings;
    }
    
}